import { render, staticRenderFns } from "./QuotaAllocation.vue?vue&type=template&id=5b52711c&scoped=true"
import script from "./QuotaAllocation.vue?vue&type=script&lang=js"
export * from "./QuotaAllocation.vue?vue&type=script&lang=js"
import style0 from "./QuotaAllocation.vue?vue&type=style&index=0&id=5b52711c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b52711c",
  null
  
)

export default component.exports